import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Stack,
    Box,
} from "@mui/material";
import { Lock } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "utils/constants";
import { setLoginTrigger } from "utils/storage.utils";

const MESSAGES = {
    assessment: {
        title: "Assessment Required",
        description: "Complete your assessment to unlock personalized prompts.",
        buttonText: "Continue Assessment",
    },
    personalized: {
        title: "Personalized Prompt",
        description: "This prompt requires you to complete your personality assessment to unlock personalized insights.",
        buttonText: "Log in to Continue",
    },
    quota: {
        title: "Prompt Limit Reached",
        description: "You've explored 5 prompts as a guest. Log in to unlock unlimited access and personalized recommendations.",
        buttonText: "Log in to Explore More",
    },
};

export default function LoginRequiredDialog({ open, onClose, reason = "personalized" }) {
    const navigate = useNavigate();
    const { title, description, buttonText } = MESSAGES[reason] || MESSAGES.personalized;

    const handleLogin = () => {
       onClose();

    if (reason === "assessment") {
        navigate(ROUTES.APP); 
    } else {
        setLoginTrigger(reason); 
        navigate(ROUTES.LOGIN); 
    }
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    p: 2,
                },
            }}
        >
            <DialogTitle sx={{ textAlign: "center", pb: 1 }}>
                <Stack alignItems="center" spacing={1}>
                    <Box
                        sx={{
                            width: 56,
                            height: 56,
                            borderRadius: "50%",
                            background: "linear-gradient(135deg, #3B82F6 0%, #2DD4BF 100%)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Lock size={28} color="#fff" />
                    </Box>
                    <Typography variant="h6" fontWeight="bold">
                        {title}
                    </Typography>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <Typography variant="body2" color="text.secondary" textAlign="center">
                    {description}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "center", pb: 2, pt: 1 }}>
                <Button
                    variant="contained"
                    onClick={handleLogin}
                    sx={{
                        textTransform: "none",
                        borderRadius: 2,
                        px: 4,
                        background: "linear-gradient(to right, #3B82F6, #2DD4BF)",
                        "&:hover": {
                            background: "linear-gradient(to right, #2563EB, #14B8A6)",
                        },
                    }}
                >
                    {buttonText}
                </Button>
                 {reason !== "assessment" && (<Button
                    variant="text"
                    onClick={onClose}
                    sx={{ textTransform: "none", color: "text.secondary" }}
                >
                    Maybe Later
                </Button>
                )}
            </DialogActions>
        </Dialog>
    );
}

